<template>
    <div class="tour-heading">
        <div class="tour-header-info" id="tag-key-details">
            <div class="tour-stats">
                <div class="icon-group">
                    <div class="stats-icon">
                        <img class="lazyload" :data-src="CityIcon" width="24" height="24"/>
                        <span class="label">{{ tour.cityName }}</span>
                    </div>
                    <div class="stats-icon">
                        <img class="lazyload" :data-src="TimeIcon" width="24" height="24"/>
                        <span class="label">{{ tour.duration }}</span>
                    </div>
                    <div class="stats-icon">
                        <img class="lazyload" :data-src="ClockIcon" width="24" height="24"/>
                        <span class="label">{{ tour.tourStartTime }}</span>
                    </div>
                    <div class="stats-icon">
                      <img class="lazyload" :data-src="MaxGroupIcon" width="24" height="24"/>
                      <span class="label">{{ tour.maxGroupSize }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CityIcon from '~/static/tour-location.svg'
import TimeIcon from '~/static/tour-timer.svg'
import ClockIcon from '~/static/tour-clock.svg'
import MaxGroupIcon from '~/static/tour-max-group.svg'

export default {
    name: 'TourDetailHeading',
    props: {
        tour: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            CityIcon: CityIcon,
            TimeIcon: TimeIcon,
            ClockIcon: ClockIcon,
            MaxGroupIcon: MaxGroupIcon
        }
    }
}
</script>

<style scoped>
.tour-stats {
    margin: 16px 0;
    padding-bottom: 24px;
}
.icon-group {
    display: grid;
    gap: 48px;
    grid-template-columns: repeat(4, fit-content(100%));
    justify-items: start;
    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin-top: 8px;
    }
}
</style>
